<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Exportation des devises</h1>
    <div class="mb-6 flex justify-between items-center">
      <div class="flex">
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-hidden max-w-7xl pt-4">
      <div class="md:inline-flex space-y-4 md:space-y-0 w-full py-4 px-6 items-center">
        <h2 class="md:w-1/3 max-w-sm mx-auto font-medium text-gray-500 text-lg">Devises en attente de paiement:</h2>
        <div class="md:w-2/3 mx-auto">
          <div>
            <div class="col-span-6 sm:col-span-2">
              <loading-button :loading="sending" class="btn-indigo mx-auto my-0" type="submit" @click.native="exportQuotes">Exporter
              </loading-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import LoadingButton from '@/Shared/LoadingButton'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import Input from "../../Jetstream/Input";

export default {
  metaInfo: {title: 'Exportation des devises'},
  layout: Layout,
  components: {
    Input,
    Icon,
    LoadingButton,
    SearchFilter,
  },
  props: {
  },
  data() {
    return {
      sending: false,
      form: {
      },
    }
  },
  watch: {
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    exportQuotes() {
      window.open(this.route('quote.exportQuotes'), "_blank");
    },
  },
}
</script>
